<ng-container *ngIf="hasValue;else spinner">
  <ng-container *ngIf="hasCustomView;else standard">
    <nb-card>
        <div [ngSwitch]="customView">
          <div class="form-title">
            <span class="subtitle">{{title || menuTitle}}</span>
            
            <container-element  [ngSwitch]="viewMode">
              <span *ngSwitchCase="'popover'">
                <div class="rollup-down">
                  <nb-icon class="arrowhead" icon="close-outline" #closeIcon (click)="togglePopover()"></nb-icon>
                </div>
              </span>
              <span *ngSwitchCase="'collapsible'">
                <ng-container *ngIf="findOpen;else collapsed">
                  <div class="rollup-down">
                    <nb-icon class="arrowhead" icon="arrowhead-up-outline" #chevron (click)="toggleIcon()"></nb-icon>
                  </div>
                </ng-container>
                <ng-template #collapsed>
                  <div class="rollup-down">
                    <nb-icon class="arrowhead" icon="arrowhead-down-outline" #chevron (click)="toggleIcon()"></nb-icon>
                  </div>
                </ng-template>
              </span>
              <span *ngSwitchDefault>
                
              </span>
            </container-element>
            <!-- <nb-menu tag="contextMenu" [items]="contextMenuItems" ubsHorizontalMenu></nb-menu> -->
            <!-- <nb-actions>
                <nb-action *ngIf="hasContextMenu" icon="chevron-down-outline"[nbContextMenu]="contextMenuItems" nbContextMenuTag="contextMenu" nbContextMenuPlacement="bottom">Related

                </nb-action>
            </nb-actions> -->
          </div> 
            <ubs-custom-container [addForm]="addForm" [customView]="customView" [action]="action" [selectedValue]="selectedValue"></ubs-custom-container>

        </div>
    </nb-card>
</ng-container>
<ng-template #standard>
    <div class="form-title">
        <span class="subtitle">{{title || menuTitle}}</span>
        <container-element  [ngSwitch]="viewMode">
          <span *ngSwitchCase="'popover'">
            <div class="rollup-down">
              <nb-icon class="arrowhead" icon="close-outline" #closeIcon (click)="togglePopover()"></nb-icon>
            </div>
          </span>
          <span *ngSwitchCase="'collapsible'">
            <ng-container *ngIf="findOpen;else collapsed">
              <div class="rollup-down">
                <nb-icon class="arrowhead" icon="arrowhead-up-outline" #chevron (click)="toggleIcon()"></nb-icon>
              </div>
            </ng-container>
            <ng-template #collapsed>
              <div class="rollup-down">
                <nb-icon class="arrowhead" icon="arrowhead-down-outline" #chevron (click)="toggleIcon()"></nb-icon>
              </div>
            </ng-template>
          </span>
          <span *ngSwitchDefault>
            
          </span>
        </container-element>
        <div class="title-actions">
          <button size="tiny" nbButton [nbContextMenu]="contextMenuItems">
            <nb-icon icon="more-horizontal-outline"></nb-icon>
          </button>
        </div>
        
        <!-- <nb-menu  tag="contextMenu" [items]="contextMenuItems" ubsHorizontalMenu></nb-menu> -->
        <!-- <nb-actions>
            <nb-action *ngIf="hasContextMenu" icon="chevron-down-outline" [nbContextMenu]="contextMenuItems" nbContextMenuTag="contextMenu" nbContextMenuPlacement="bottom">Related
            </nb-action>
        </nb-actions> -->
      </div>
    <ubs-ofbiz-form [ofbizForm]="addForm" [title]="title" [state]="state" [parameters]="parameters" (openDialogContainerEvent)="openDialogContainer($event)" [lookupSelectedValue]="lookupSelectedValue" [target]="target"></ubs-ofbiz-form>
</ng-template>
</ng-container>
<ng-template #spinner>
  <nb-card size="small">
    <nb-card-body [nbSpinner]="true"
    nbSpinnerStatus="danger"
    nbSpinnerSize="large"
    nbSpinnerMessage="Working on it ... "></nb-card-body>
  </nb-card>
  
</ng-template>



